import {extractErrorMessage } from '../../utilities';
import logger from '../../utils/logging';
import MidwayClient from './spotcp-midway_client';

let selfServiceClient;

export function getSelfServiceClient() {
    if(!selfServiceClient) {
        selfServiceClient = new SelfServiceClient();
    }
    return selfServiceClient;
}

/**
 * Service client to call SelfServiceCostCorrectionTool Lambda for Allow List and Deny List
 */
export class SelfServiceClient extends MidwayClient {
    constructor(props) {
        super();
        this.props = props || {};
    }

    clientLoaded = (client) => {
        this.selfServiceClient = client;

        if (this.props.hasOwnProperty('onReady')) {
            this.props.onReady();
        }
    };

    post = (endpoint, payload, callback, errorCallback) => {
        this.selfServiceClient.post(endpoint, payload)
            .then((response) => {
                logger.info(response);
                callback(response);
            })
            .catch((error)=>{
                logger.error(extractErrorMessage(error), error);
                if(errorCallback) {
                    errorCallback(error);
                }
            });
    }

    postDenyList = (callback, errorCallback, payload) => {
        logger.info('Attempting to post DenyList Inventory Cost.', payload);
        this.post('inventoryCostDenylist', payload, callback, errorCallback);
    }

    postAllowList = (callback, errorCallback, payload) => {
        logger.info('Attempting to post AllowList Vendor Code.', payload);
        this.post('vendorCodeAllowList', payload, callback, errorCallback);
    }

}


// WEBPACK FOOTER //
// ./src/components/spotlight/spotcp-self-service-client.jsx